import { render, staticRenderFns } from "./singleFeedComponent.vue?vue&type=template&id=cd5cb2d0&scoped=true"
import script from "./singleFeedComponent.vue?vue&type=script&lang=js"
export * from "./singleFeedComponent.vue?vue&type=script&lang=js"
import style0 from "./singleFeedComponent.vue?vue&type=style&index=0&id=cd5cb2d0&prod&scoped=true&lang=css"
import style1 from "./singleFeedComponent.vue?vue&type=style&index=1&id=cd5cb2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5cb2d0",
  null
  
)

export default component.exports